(function($) {
    $(document).ready(function() {
        console.log('Wave');

        $(window).scroll(function() {
            scrollTop = $(window).scrollTop() + $(window).height();
            waveTop = $(".c-footer_wave").offset().top;

            if (scrollTop >= waveTop) {
                // Element is in viewport now
                target = $(".c-footer_wave_text");
                currentOffset = parseFloat($(target).attr('startOffset'));
                startOffset = -5;
                gap = 15;

                scrollableHeight = $(document).height() - waveTop;
                percent = ((scrollTop - waveTop) / scrollableHeight);
                diff = gap * percent;

                $(target).attr('startOffset', (startOffset + diff) + '%');
            }
        });
    });
}(jQuery));
